"use strict";

(function () {
  function init(nav) {
    var list = nav.querySelector(".categories-bar__list");
    var scrollbar = nav.querySelector(".categories-bar__scrollbar");
    var thumb = nav.querySelector(".categories-bar__scrollbar-thumb");

    if (!list || !scrollbar || !thumb) return;

    var metrics = { scrollable: false, railWidth: 0, ratio: 0, maxScroll: 0 };

    function measure() {
      var scrollWidth = list.scrollWidth;
      var clientWidth = list.clientWidth;
      metrics.scrollable = scrollWidth - clientWidth > 1;
      // Toggle visibility first so the rail has a measurable width below.
      nav.classList.toggle("is-scrollable", metrics.scrollable);
      if (!metrics.scrollable) return;
      metrics.ratio = clientWidth / scrollWidth;
      metrics.maxScroll = scrollWidth - clientWidth;
      metrics.railWidth = scrollbar.clientWidth;
      thumb.style.width = metrics.railWidth * metrics.ratio + "px";
      renderThumb();
    }

    function renderThumb() {
      if (!metrics.scrollable) return;
      var travel = metrics.railWidth * (1 - metrics.ratio);
      var progress = list.scrollLeft / metrics.maxScroll;
      thumb.style.transform =
        "translateX(" + Math.min(Math.max(progress, 0), 1) * travel + "px)";
    }

    var ticking = false;
    list.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          renderThumb();
          ticking = false;
        });
      },
      { passive: true }
    );

    if ("ResizeObserver" in window) {
      new ResizeObserver(measure).observe(list);
    } else {
      window.addEventListener("resize", measure);
    }

    measure();
  }

  function boot() {
    document.querySelectorAll(".categories-bar").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
